const HEADER_HEIGHT = '4rem';

export { HEADER_HEIGHT };
